import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';
import { AuthContext } from '../context/AuthContext';

const CreateEvent = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [formData, setFormData] = useState({
    title: '',
    description: '',
    date: '',
    startTime: '',
    endTime: '',
    address: '',
    city: '',
    category: 'Other',
    imageUrl: '',
    maxGuests: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const eventData = {
        title: formData.title,
        description: formData.description,
        date: formData.date,
        startTime: formData.startTime,
        endTime: formData.endTime,
        location: {
          address: formData.address,
          city: formData.city,
        },
        category: formData.category,
        imageUrl: formData.imageUrl || '',
        maxGuests: formData.maxGuests ? parseInt(formData.maxGuests) : null,
        // ── Firebase-specific fields ──
        isPublic: true,
        creatorId: user.uid,
        creatorName: user.displayName || user.email,
        createdAt: serverTimestamp(),
      };

      const docRef = await addDoc(collection(db, 'events'), eventData);
      navigate(`/events/${docRef.id}`);
    } catch (err) {
      console.error('Failed to create event:', err);
      setError('Failed to create event. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: '600px', margin: '2rem auto', padding: '0 2rem' }}>
      <h1 style={{ marginBottom: '2rem', color: '#1f2937' }}>Create New Event</h1>

      {error && (
        <div style={{
          backgroundColor: '#fee2e2', color: '#991b1b',
          padding: '0.75rem', borderRadius: '4px', marginBottom: '1rem'
        }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} style={{
        backgroundColor: 'white', padding: '2rem',
        borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
            Event Title *
          </label>
          <input
            type="text" name="title" value={formData.title}
            onChange={handleChange} required
            style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
            Description
          </label>
          <textarea
            name="description" value={formData.description}
            onChange={handleChange} rows="4"
            style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
          />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Date *</label>
            <input
              type="date" name="date" value={formData.date}
              onChange={handleChange} required
              style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Category</label>
            <select
              name="category" value={formData.category} onChange={handleChange}
              style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
            >
              <option value="Birthday">Birthday</option>
              <option value="Wedding">Wedding</option>
              <option value="Corporate">Corporate</option>
              <option value="Social">Social</option>
              <option value="Conference">Conference</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1rem' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Start Time *</label>
            <input
              type="time" name="startTime" value={formData.startTime}
              onChange={handleChange} required
              style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>End Time *</label>
            <input
              type="time" name="endTime" value={formData.endTime}
              onChange={handleChange} required
              style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
            />
          </div>
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>Address *</label>
          <input
            type="text" name="address" value={formData.address}
            onChange={handleChange} required placeholder="123 Main St"
            style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>City *</label>
          <input
            type="text" name="city" value={formData.city}
            onChange={handleChange} required placeholder="Lilongwe"
            style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
          />
        </div>

        <div style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
            Image URL (optional)
          </label>
          <input
            type="url" name="imageUrl" value={formData.imageUrl}
            onChange={handleChange} placeholder="https://example.com/image.jpg"
            style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
          />
        </div>

        <div style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
            Max Guests (optional)
          </label>
          <input
            type="number" name="maxGuests" value={formData.maxGuests}
            onChange={handleChange} min="1" placeholder="Leave empty for unlimited"
            style={{ width: '100%', padding: '0.75rem', border: '1px solid #d1d5db', borderRadius: '4px' }}
          />
        </div>

        <div style={{ display: 'flex', gap: '1rem' }}>
          <button
            type="submit" disabled={loading}
            style={{
              flex: 1, backgroundColor: '#6366f1', color: 'white',
              padding: '0.75rem', border: 'none', borderRadius: '4px',
              fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? 'Creating...' : 'Create Event'}
          </button>
          <button
            type="button" onClick={() => navigate('/dashboard')}
            style={{
              flex: 1, backgroundColor: '#e5e7eb', color: '#374151',
              padding: '0.75rem', border: 'none', borderRadius: '4px',
              fontWeight: 'bold', cursor: 'pointer'
            }}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default CreateEvent;
